// Module
var code = "<div class=\"form-center\">\n    <div class=\"vtform\">\n        <form name=\"vtForm\" novalidate>\n            <div data-ng-transclude=\"header\"></div>\n            <div data-ng-transclude=\"body\"></div>\n            <div data-ng-transclude=\"footer\"></div>\n        </form>\n    </div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'components/form/vt-form.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;